import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _toConsumableArray from "/Users/yangwei/work/project/cat_help_admin/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import _defineProperty from "/Users/yangwei/work/project/cat_help_admin/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { getPage as _getPage, addObj, putObj } from '@/api/wxmp/wxmsg';
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import store from "@/store";
import WxReplySelect from '@/components/wx-reply/main.vue';
import WxNews from '@/components/wx-news/main.vue';
import WxVideoPlayer from '@/components/wx-video-play/main.vue';
import WxVoicePlayer from '@/components/wx-voice-play/main.vue';
export default {
  name: "wxMsg",
  components: {
    WxReplySelect: WxReplySelect,
    WxNews: WxNews,
    WxVideoPlayer: WxVideoPlayer,
    WxVoicePlayer: WxVoicePlayer
  },
  props: {
    wxUserId: {
      type: String
    },
    appId: {
      type: String
    }
  },
  data: function data() {
    return {
      nowStr: new Date().getTime(),
      objData: {
        repType: 'text'
      },
      mainLoading: false,
      sendLoading: false,
      tableLoading: false,
      loadMore: true,
      tableData: [],
      page: {
        total: 0,
        // 总页数
        currentPage: 1,
        // 当前页数
        pageSize: 14,
        // 每页显示多少条
        ascs: [],
        //升序字段
        descs: 'create_time' //降序字段
      },

      option: {
        props: {
          avatar: 'avatar',
          author: 'author',
          body: 'body'
        }
      }
    };
  },
  created: function created() {
    this.refreshChange();
  },
  destroyed: function destroyed() {
    this.disconnect();
  },
  mounted: function mounted() {
    this.initWebSocket();
  },
  beforeDestroy: function beforeDestroy() {
    // 页面离开时断开连接,清除定时器
    this.disconnect();
    clearInterval(this.timer);
  },
  computed: _objectSpread({}, mapGetters(['permissions'])),
  methods: {
    initWebSocket: function initWebSocket() {
      this.connection();
      var self = this;
      //断开重连机制,尝试发送消息,捕获异常发生时重连
      this.timer = setInterval(function () {
        try {
          self.stompClient.send("test");
        } catch (err) {
          console.log("断线了: " + err);
          self.connection();
        }
      }, 5000);
    },
    connection: function connection() {
      var _this = this;
      var token = store.getters.access_token;
      var headers = {
        'Authorization': 'Bearer ' + token
      };
      // 建立连接对象
      this.socket = new SockJS('/weixin/ws'); //连接服务端提供的通信接口，连接以后才可以订阅广播消息和个人消息
      // 获取STOMP子协议的客户端对象
      this.stompClient = Stomp.over(this.socket);

      // 向服务器发起websocket连接
      this.stompClient.connect(headers, function () {
        _this.stompClient.subscribe('/weixin/wx_msg' + _this.wxUserId, function (msg) {
          // 订阅服务端提供的某个topic;
          var data = JSON.parse(msg.body);
          data.createTime = _this.$moment(data.createTime).format('YYYY-MM-DD HH:mm:ss');
          _this.tableData = [].concat(_toConsumableArray(_this.tableData), [data]); //刷新消息
          _this.scrollToBottom();
          //标记为已读
          if (data.type == '1') {
            putObj({
              id: data.id,
              readFlag: '0'
            }).then(function (data) {});
          }
        });
      }, function (err) {});
    },
    disconnect: function disconnect() {
      if (this.stompClient != null) {
        this.stompClient.disconnect();
        console.log("Disconnected");
      }
    },
    sendMsg: function sendMsg() {
      var _this2 = this;
      if (this.objData) {
        if (this.objData.repType == 'news') {
          this.objData.content.articles = [this.objData.content.articles[0]];
          this.$message({
            showClose: true,
            message: '图文消息条数限制在1条以内，已默认发送第一条',
            type: 'success'
          });
        }
        this.sendLoading = true;
        addObj(Object.assign({
          appId: this.appId,
          wxUserId: this.wxUserId
        }, this.objData)).then(function (data) {
          _this2.sendLoading = false;
          data = data.data.data;
          _this2.tableData = [].concat(_toConsumableArray(_this2.tableData), [data]);
          _this2.scrollToBottom();
          _this2.objData = {
            repType: 'text'
          };
        }).catch(function () {
          _this2.sendLoading = false;
        });
      }
    },
    scrollToBottom: function scrollToBottom() {
      var _this3 = this;
      this.$nextTick(function () {
        var div = document.getElementById('msg-div' + _this3.nowStr);
        div.scrollTop = div.scrollHeight;
      });
    },
    loadingMore: function loadingMore() {
      this.page.currentPage++;
      this.getPage(this.page);
    },
    getPage: function getPage(page, params) {
      var _this4 = this;
      this.tableLoading = true;
      _getPage(Object.assign({
        current: page.currentPage,
        size: page.pageSize,
        descs: page.descs,
        ascs: page.ascs,
        appId: this.appId,
        wxUserId: this.wxUserId
      }, params)).then(function (response) {
        var msgDiv = document.getElementById('msg-div' + _this4.nowStr);
        var scrollHeight = 0;
        if (msgDiv) {
          scrollHeight = msgDiv.scrollHeight;
        }
        var data = response.data.data.records.reverse();
        _this4.tableData = [].concat(_toConsumableArray(data), _toConsumableArray(_this4.tableData));
        _this4.page.total = response.data.data.total;
        _this4.tableLoading = false;
        if (data.length < _this4.page.pageSize || data.length == 0) {
          _this4.loadMore = false;
        }
        if (_this4.page.currentPage == 1) {
          //定位到消息底部
          _this4.scrollToBottom();
        } else {
          if (data.length != 0) {
            _this4.$nextTick(function () {
              //定位滚动条
              if (scrollHeight != 0) {
                msgDiv.scrollTop = document.getElementById('msg-div' + _this4.nowStr).scrollHeight - scrollHeight - 100;
              }
            });
          }
        }
        _this4.page.currentPage = page.currentPage;
        _this4.page.pageSize = page.pageSize;
      });
    },
    /**
     * 刷新回调
     */
    refreshChange: function refreshChange() {
      this.getPage(this.page);
    }
  }
};